import { AxiosResponse } from 'axios';
import { IQuoteImportApi, api } from '../base';
import { ImportQuoteFileHistoryResponse } from '@/main/models/response';
import { ImportQuoteFileHistoryRequest } from '@/main/models/request';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { Result } from '@/main/models/common/resultResponse';
import { TimeoutRequestConfigurationEnum } from '@/main/services/enum/TimeoutRequestConfigurationEnum';

const baseRoute: string = 'QuoteImport';

export class QuoteImportApi extends IQuoteImportApi {
  getImportHistory(
    request: ImportQuoteFileHistoryRequest
  ): Promise<
    AxiosResponse<PaginationResponse<ImportQuoteFileHistoryResponse[]>>
  > {
    return api.get(`${baseRoute}/getImportHistory`, { params: request });
  }

  downloadFileImportHistory(
    guidQuoteImport: string
  ): Promise<AxiosResponse<Result<string>>> {
    return api.get(
      `${baseRoute}/downloadFileImportHistory/${guidQuoteImport}`,
      {
        timeout: TimeoutRequestConfigurationEnum.ThreeMinutesInMilliseconds
      }
    );
  }
  downloadErrorFileImportHistory(
    guidQuoteImport: string
  ): Promise<AxiosResponse<Result<string>>> {
    return api.get(
      `${baseRoute}/downloadErrorFileImportHistory/${guidQuoteImport}`
    );
  }
}

